export default __webpack_public_path__ + "static/media/ttauri.07fb0681.jpg";